<template>
  <div class="expiration-remind home-top-remind" v-if="expireWarn.visible && !isExp">
    <xin-icon xin-type="icon_tips_standard" class="m_r4" />
    <div class="notice-close c_pointer" @click="expireWarn.visible = false">
      <xin-icon xin-type="close" class="sk--hover-text"></xin-icon>
    </div>
    <p class="msg-text">
      {{ $xinI18n('尊敬的','Home-zunjingde') }} {{ accName }}，
      {{ $xinI18n('谨提醒您','Home-jintixingnin') }}：{{ $xinI18n('贵公司账号','Home-guigongsizhanghao') }}
      <span style="color: #F73838"> {{$xinI18n('还有 {#1} 天到期','Home-haiyouxxtiandaoqi',[expireWarn.day])}}</span>，
      {{ $xinI18n('为避免影响贵公司业务，请及时联系薪人薪事服务顾问，沟通续约事宜！','Home-lianxiguwenxuyue') }}
    </p>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {HomeApi} from '@/module/home/service/home-api.service';

const moduleInfra = namespace('moduleInfra');

  @Component({})
  export default class ExpirationRemind extends Vue {
    @moduleInfra.Getter('getIsExp') public isExp!: boolean;
    @moduleInfra.Getter('getAccName') public accName!: boolean;

    //到期提醒
    expireWarn = {
      visible: false,
      day: 0
    };

    created() {
      this.getContractDays()
    }

    //获取合同剩余天数
    getContractDays() {
      HomeApi.getContractDays()
        .then(res => {
          if (res.status) {
            this.expireWarn = {
              day: res.data.day,
              visible: [90, 30, 7, 3].includes(+res.data.day)
            };
          }
        });
    }

  }
</script>

<style lang="scss" scoped>
.expiration-remind {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 0 32px;
  background: #F4FAFF;
  font-size: 12px;
  font-weight: 400;
  color: #3D3D3D;
  .xin-icon{
    font-size: 13px;
    color: #32A7FE;
  }
  .notice-close{
    position: absolute;
    right: 8px;
    .xin-icon{
      color: var(--xs-text-color-gray);
    }
  }
}
</style>
